import Box from "@mui/material/Box";
import Spinner2 from './Spinner2';
//---------------------------------------------------------

export default function SpinnerBox(props) {
  return (
    <Box  className='ctnItmAC' sx={{padding: '1rem', }}//pagging: '5px'
    ><Spinner2 {...props} /></Box>
  );
}